export default __webpack_public_path__ + "static/media/twitter-icon-hol.4426176e.png";